module.exports = __webpack_public_path__ + "img/ikonka-09.ea08b0a0.svg";